import { render } from "./index.vue?vue&type=template&id=68eb29f3&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=68eb29f3&lang=less&scoped=true"

import exportComponent from "/Users/gejiayang/Desktop/chunlin-overseas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68eb29f3"]])

export default __exports__